/* sucrase/dist/esm/util/elideImportEquals.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.default = elideImportEquals;
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    function elideImportEquals(tokens) {
        // import
        tokens.removeInitialToken();
        // name
        tokens.removeToken();
        // =
        tokens.removeToken();
        // name or require
        tokens.removeToken();
        // Handle either `import A = require('A')` or `import A = B.C.D`.
        if (tokens.matches1(types_1.TokenType.parenL)) {
            // (
            tokens.removeToken();
            // path string
            tokens.removeToken();
            // )
            tokens.removeToken();
        }
        else {
            while (tokens.matches1(types_1.TokenType.dot)) {
                // .
                tokens.removeToken();
                // name
                tokens.removeToken();
            }
        }
    }
}
